export default __webpack_public_path__ + "static/media/UserCircleActive.485c1a86.svg";